
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Image } from '@zhike/ti-ui';
import { css } from 'aphrodite';
import { handleAnswer } from './utils/handleReport';
import styles from './styles';

// 结束
export default class Test extends Component {
// 参数
static propTypes = {
  report: PropTypes.object.isRequired,
};
// 构造函数
constructor(props) {
  super(props);
  this.state = {
    result: {},
  }
}

// 模块即将加载
async componentDidMount() {
  const { report } = this.props;
  this.setState({
    result: handleAnswer(report),
  });
}

// 渲染
render() {
  const { result } = this.state;
  const { testSocre, rank, socre } = result;
  return (
    <View className={styles.containerNew}>
      <Image
        style={{ width: '90px', height: '90px', padding: '20px' }}
        src={require('../assets/success.png')}
      />
      <View className={styles.text}>
      smart的小伙伴如果在做题中，
      传的redirect参数，则跳转指定路径
      </View>
      <View className={styles.text}>测试的结果如下</View>
      <View className={styles.text}>测试分数为：<span className={css(styles.tip)}>{testSocre}</span></View>
      <View className={styles.text}>测试的等级为：<span className={css(styles.tip)}>{rank}</span> </View>
      <View className={styles.text}>转化为 9 分制为：<span className={css(styles.tip)}>{socre}</span> </View>
    </View>);
}
}



// WEBPACK FOOTER //
// ./src/components/report/test.js